<template>
	<div class="product-page">
		<!-- Search Bar -->
		<div class="search-container" :class="{ 'search-container-fixed': isSearchFixed }">
			<div class="search-wrapper">
				<div class="custom-search-input">
					<el-input type="text" :placeholder="$t('searchPlaceholder')" v-model="searchKeyword"
						class="search-input" @keyup.enter.native="search" />
					<button class="search-button" @click="search">{{ $t('search') }}</button>
				</div>
				<div class="upload-button">
					<button class="image-search-button" @click="triggerFileInput">
						<i class="el-icon-upload" style="font-size: 24px;"></i>
						<span>{{$t('searchByImage')}}</span>
					</button>
					<input type="file" ref="fileInput" class="file-input" accept="image/*" multiple
						@change="handleFileUpload" title="">
				</div>
			</div>
		</div>

		<div class="container">
			<!-- 查询条件区域 -->
			<div>
				<ProductSearchFilter ref="productSearchFilter" :is-fixed="isSearchFixed" module="product"
					@filter-change="handleFilterChange" :platform-id="platform" />
			</div>
			<!-- 商品列表 -->
			<div :style="{marginTop:isSearchFixed?'200px':'0'}">
				<ProductList ref="productList" :category-id="selectCategoryId" :keyword="searchKeyword" :brand="brand"
					:platform="platform" :price-range="priceRange" :shipping="shipping" :sort-by="sortBy"
					:scroll-top="isSearchFixed?130:0" source="product"/>
			</div>
		</div>

		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />

		<EnquiryDialog :visible.sync="enquiryDialogVisible" />

		<ComplaintDialog :visible.sync="complaintDialogVisible" />
	</div>
</template>

<script>
	import ProductList from '@/components/ProductList.vue';
	import ProductSearchFilter from '@/components/ProductSearchFilter.vue'
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue'
	export default {
		name: 'Product',
		components: {
			ProductList,
			ProductSearchFilter,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				searchKeyword: '',
				isSearchFixed: false,
				selectCategoryId: null, //选中的商品分类ID
				brand: "all",
				platform: "all",
				priceRange: "all",
				shipping: "all",
				sortBy: "releaseTime"
			}
		},
		mounted() {
			// 添加滚动事件监听器
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
			//加载代购平台
			if (this.$refs.productSearchFilter && typeof this.$refs.productSearchFilter.init === 'function') {
				this.$refs.productSearchFilter.init();
			}
			// 从路由参数获取搜索关键词
			if (this.$route.query.keyword) {
				this.searchKeyword = this.$route.query.keyword
			}
			// 从路由参数获取代购平台id，并通过监听代购平台id变化进行查询，最终也是执行loadGoods
			if (this.$route.query.platformId) {
				this.platform = this.$route.query.platformId + ''
			} else {
				//代购平台为null，正常加载
				setTimeout(() => {
					this.loadGoods();
				}, 200)
			}
		},
		methods: {
			handleFilterChange(filter) {
				console.log(filter)
				this.brand = filter.brand;
				this.platform = filter.platform;
				this.priceRange = filter.priceRange;
				this.shipping = filter.shipping;
				this.sortBy = filter.sortBy;
				//加载商品信息
				setTimeout(() => {
					this.loadGoods();
				}, 200)
			},
			//加载商品列表
			loadGoods() {
				if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
					this.$refs.productList.init();
				}
			},
			search() {
				this.loadGoods();
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// 简单实现搜索框固定效果
				this.isSearchFixed = scrollTop > 100;
			},
			// 触发文件选择
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			// 处理文件上传
			handleFileUpload(event) {
				const files = event.target.files;
				if (files.length > 0) {
					// 处理文件并存储到sessionStorage
					const fileDataArray = [];
			
					// 处理每个文件
					for (let i = 0; i < files.length; i++) {
						const file = files[i];
						// 创建文件URL用于预览
						const imageUrl = URL.createObjectURL(file);
			
						// 创建文件数据对象
						const fileData = {
							url: imageUrl,
							name: file.name,
							size: file.size,
							type: file.type
						};
			
						fileDataArray.push(fileData);
					}
			
					// 存储文件数据到sessionStorage
					sessionStorage.setItem('uploadedFiles', JSON.stringify(fileDataArray));
			
					// 跳转到产品搜索页面
					if (files.length <= 6) {
						this.$router.push({
							path: '/product-search-image'
						});
					} else {
						this.$router.push({
							path: '/product-search-more-image'
						});
					}
				}
			},
		}
	}
</script>

<style scoped>
	.product-page {
		padding: 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	/* Search bar styles */
	.search-container {
		display: flex;
		justify-content: center;
		z-index: 10;
	}

	.search-container.search-container-fixed {
		position: fixed !important;
		top: 0px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 1000 !important;
	}

	.search-container.search-container-fixed .search-wrapper {
		background-color: white !important;
		padding: 10px 0;
	}

	.search-container.search-container-fixed .custom-search-input {
		width: 60%;
		border-color: #F59A23;
		background-color: rgba(0, 0, 0, 0.05);
	}

	.search-container.search-container-fixed .search-button {
		height: 35px;
		width: 100px;
		font-size: 14px;
	}

	.search-container.search-container-fixed .image-search-button {
		height: 40px;
		padding: 0 15px;
		font-size: 14px;
	}

	.search-container.search-container-fixed :deep .el-input__inner {
		color: #333;
		height: 35px;
	}

	.search-wrapper {
		padding: 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 60%;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.05);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 60px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
	}

	.search-button:hover {
		background-color: #F59A23;
	}
	
	.upload-button {
		position: relative;
	}

	.custom-upload-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 15px 20px;
		background-color: #D9001B;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		transition: background-color 0.3s;
	}
	
	.custom-upload-btn:hover {
		background-color: #ff4400;
	}
	
	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}
	
	.image-search-button {
		background-color: #D9001B;
		color: white;
		border: none;
		height: 65px;
		padding: 0 20px;
		cursor: pointer;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 5px;
		border-radius: 10px;
		transition: background-color 0.3s;
		font-weight: bold;
	}
	
	.image-search-button:hover {
		background-color: #D9001B;
	}
</style>